import api from '../../../api/nexceo/aiPendingActions';

const state = {
  leadActions: {},
  globalActions: [],
  isLoading: false,
};

const getters = {
  getActionsForLead: s => leadId => s.leadActions[leadId] || [],
  getGlobalActions: s => s.globalActions,
  pendingCountForLead: s => leadId =>
    (s.leadActions[leadId] || []).filter(a => a.status === 'pending').length,
  isLoading: s => s.isLoading,
};

const mutations = {
  SET_LEAD_ACTIONS(s, { leadId, actions }) {
    s.leadActions = { ...s.leadActions, [leadId]: actions };
  },
  SET_GLOBAL_ACTIONS(s, actions) {
    s.globalActions = actions;
  },
  UPDATE_ACTION(s, updated) {
    s.globalActions = s.globalActions.map(a =>
      a.id === updated.id ? updated : a
    );
    const leadId = updated.lead_id;
    if (leadId && s.leadActions[leadId]) {
      s.leadActions = {
        ...s.leadActions,
        [leadId]: s.leadActions[leadId].map(a =>
          a.id === updated.id ? updated : a
        ),
      };
    }
  },
  SET_LOADING(s, val) {
    s.isLoading = val;
  },
};

const actions = {
  fetchForLead: async ({ commit }, { accountId, leadId }) => {
    commit('SET_LOADING', true);
    try {
      const { data } = await api.listForLead(accountId, leadId);
      commit('SET_LEAD_ACTIONS', { leadId, actions: data });
    } finally {
      commit('SET_LOADING', false);
    }
  },

  fetchGlobal: async ({ commit }, { accountId, filters = {} }) => {
    commit('SET_LOADING', true);
    try {
      const { data } = await api.list(accountId, filters);
      commit('SET_GLOBAL_ACTIONS', data);
    } finally {
      commit('SET_LOADING', false);
    }
  },

  approve: async ({ commit }, { accountId, actionId }) => {
    const { data } = await api.approve(accountId, actionId);
    commit('UPDATE_ACTION', data);
    return data;
  },

  reject: async ({ commit }, { accountId, actionId, reason }) => {
    const { data } = await api.reject(accountId, actionId, reason);
    commit('UPDATE_ACTION', data);
    return data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
